import { ErrorHandler, Injectable } from "@angular/core";
import { ILogger } from "./logger/Logger";
import { PayloadError } from "./logger/PayloadError";


@Injectable()
export class LivepanelErrorHandler implements ErrorHandler {
    constructor(private logger: ILogger) { }

    async handleError(error: any): Promise<void> {
        let errorMensaje = "";
        if (error.rejection) {
            error = error.rejection;
        }

        if (error.name === "HttpErrorResponse" && error.status !== 400) {
            errorMensaje = `Error al obtener la url ${error.url} con codigo ${error.status}`;
        } else if (error.headers) {
            if (!error.ok && error.status !== 401) {
                if (Array.isArray(error.error)) {
                    errorMensaje = error.error.join(".\n");
                } else {
                    const claves = Object.keys(error.error);

                    claves.forEach(clave => {
                        if (Array.isArray(error.error[clave])) {
                            errorMensaje += `${clave}: ${error.error[clave].join(".\n")}`;
                        }
                    });
                }
            }
        } else {
            errorMensaje = error.message ? error.message : error.toString();
        }

        this.logger.error(
            new PayloadError(errorMensaje, `\n${error.stack?.substring(error.stack.indexOf("    at "))}`)
        );
    }
}
